export const rentalTypes = [
  $localize`Apartment`,
  $localize`Barn`,
  $localize`Boat`,
  $localize`B&B`,
  $localize`Building`,
  $localize`Bungalow`,
  $localize`Cabin`,
  $localize`Campground`,
  $localize`Caravan`,
  $localize`Castle`,
  $localize`Chacara`,
  $localize`Chalet`,
  $localize`Chateau`,
  $localize`Condo`,
  $localize`Cottage`,
  $localize`Estate`,
  $localize`Farmhouse`,
  $localize`Guesthouse`,
  $localize`Hostel`,
  $localize`Hotel`,
  $localize`House`,
  $localize`Lodge`,
  $localize`Mas`,
  $localize`Mill`,
  $localize`Mobile Home`,
  $localize`Other`,
  $localize`Private House`,
  $localize`Private Room`,
  $localize`RV`,
  $localize`Resort`,
  $localize`Riad`,
  $localize`Studio`,
  $localize`Tower`,
  $localize`Townhouse`,
  $localize`Trullo`,
  $localize`Villa`,
  $localize`Yacht`,
]
